const getNewOrdersModuleAssetUrl = () => {
	return new Worker(new URL("../../workers/newOrdersPDFWorker.worker.tsx", import.meta.url), { type: "module" });
};

export default getNewOrdersModuleAssetUrl;
